import React from 'react';
import { VerificationCodeInputProps } from './types';
import { useInputHelper } from 'ui-builder';

import Layout from './Layout';

export function VerificationCodeInput(props: VerificationCodeInputProps) {
  const inputHelper = useInputHelper(props);

  return (
    <Layout
      length={props.length || 6}
      {...inputHelper.getBaseInputLayoutProps()}
    />
  );
} 